import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './style.css';

class ErrorBoundary extends React.Component<{children:React.ReactNode},{error:boolean}> {
  state={error:false};static getDerivedStateFromError(){return {error:true};}
  render(){return this.state.error?<main className="fatal"><h1>Ownwork needs a refresh</h1><p>Your saved workspace remains on this computer.</p><button onClick={()=>location.reload()}>Reload workspace</button></main>:this.props.children;}
}
createRoot(document.getElementById('root')!).render(<React.StrictMode><ErrorBoundary><App/></ErrorBoundary></React.StrictMode>);
